import React from 'react'
import { useStyles } from './style'

const FooterToolbar = () => {
  const classes = useStyles()
  const year = new Date().getFullYear()

  return (
    <div className={classes.root}>
      © Mind Tools Ltd {year}. All rights reserved.
    </div>
  )
}

export default FooterToolbar
